import React, { useContext, useEffect, useState } from 'react'
import { StoresContext } from '@App/contexts'
import { Outlet, useParams } from 'react-router'
import { observer } from 'mobx-react'
import './index.scss'
import RightsholderSubNavigationMobile from '@Components/Navigations/RightsholderSubNavigationMobile'
import RightsholderSubNavigation from '@Components/Navigations/RightsholderSubNavigation'
import PointPreloader from '@Components/Preloaders/PointPreloader'
import { PARAM } from '@App/navigation/param'
import useRightsholderReset from '@App/services/useRightsholderReset'
import Popup from '@Components/Popups/Popup'
import ModalPortal from '@Components/Popups/ModalPortal'
import RestrictedRightsholderPopup from '@Components/Popups/RestrictedRightsholderPopup'
import clsx from 'clsx'

const RightsholderLayout = () => {
    const { rightsholderStore, userStore, rightsholderUserStore, uiStore, rightsholderSearchStore } =
        useContext(StoresContext)
    const [loading, setLoading] = useState<boolean>(false)
    const params = useParams<typeof PARAM>()
    const resetRightsholder = useRightsholderReset()

    const [restrictedModalIsClosed, setRestrictedModalIsClosed] = useState(false)

    useEffect(() => {
        getData().then()
    }, [params.rightsholderId])

    useEffect(
        () => () => {
            resetRightsholder()
        },
        []
    )

    const getUserForRightsHolderToAbility = async () => {
        const currentUserId = userStore.userInfo?.exposedId
        if (currentUserId) {
            await rightsholderUserStore.loadRightsholderUserToAbility(currentUserId)
        }
    }

    const getRightsholdersForMember = async () => {
        if (!rightsholderSearchStore.rightsholders) {
            await rightsholderSearchStore.loadRightsholders({})
        }
    }

    const getData = async () => {
        setLoading(true)
        await rightsholderStore.setCurrentRightsholderId(Number(params.rightsholderId))
        await getRightsholdersForMember()
        await getUserForRightsHolderToAbility()
        setLoading(false)
    }

    return rightsholderStore.optionalMemberSummary && rightsholderStore.optionalCurrentRightsholderId ? (
        <>
            <title>Member</title>
            {rightsholderStore.isRestricted && !restrictedModalIsClosed && (
                <ModalPortal isOpen={!restrictedModalIsClosed} onClose={() => setRestrictedModalIsClosed(true)}>
                    <Popup showClose onClose={() => setRestrictedModalIsClosed(true)}>
                        <RestrictedRightsholderPopup />
                    </Popup>
                </ModalPortal>
            )}
            <main className="rightsholder-scene">
                {loading ? (
                    <PointPreloader />
                ) : (
                    <>
                        {uiStore.showSubNavigation &&
                            (uiStore.isMobile ? <RightsholderSubNavigationMobile /> : <RightsholderSubNavigation />)}
                        <div
                            className={clsx(
                                'rightsholder-switch-container',
                                !uiStore.showSubNavigation && 'hidden-sidebar'
                            )}
                        >
                            <div className="global-container">
                                <Outlet />
                            </div>
                        </div>
                    </>
                )}
            </main>
        </>
    ) : (
        <></>
    )
}

export default observer(RightsholderLayout)
